import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';

import Login from './pages/Login';
import Signup from './pages/Signup';
import Home from './pages/Home';
import PublicReport from './pages/PublicReport';
import Fraud from './pages/FrudDB';
import Settings from './pages/Settings';
import TelegramSearch from './pages/TelegramSearch';
import StateInfo from './pages/StateInfo';
import Guide from './pages/Guide';
import AutoScan from './pages/AutoScan';
import Navbar from './components/Navbar';

// A wrapper for protected routes
function ProtectedRoute({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: '#64748b' }}>
        Loading authentication...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function App() {
  return (
    <div className="app-shell" style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <BrowserRouter>
        <Navbar />
        <div style={{ flex: 1, overflow: 'auto' }}>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            
            {/* Protected Routes */}
            <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
            <Route path="/publicReport" element={<ProtectedRoute><PublicReport /></ProtectedRoute>} />
            <Route path="/fraud" element={<ProtectedRoute><Fraud /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/telegram-search" element={<ProtectedRoute><TelegramSearch /></ProtectedRoute>} />
            <Route path="/auto-scan" element={<ProtectedRoute><AutoScan /></ProtectedRoute>} />
            <Route path="/state-info" element={<ProtectedRoute><StateInfo /></ProtectedRoute>} />
            <Route path="/guide" element={<ProtectedRoute><Guide /></ProtectedRoute>} />
            
            {/* Catch-all redirects */}
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="*" element={<Navigate to="/home" replace />} />
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
